var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownLayer = function SvgDownLayer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6E718F",
    d: "M2 13h3v3c0 1.103.897 2 2 2h9c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2h-3V2c0-1.103-.897-2-2-2H2C.897 0 0 .897 0 2v9c0 1.103.897 2 2 2m13.997 3H7V7h9z"
  })));
};
export default SvgDownLayer;